// // src/pages/EditBusinessPage.jsx
// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Container,
//   Box,
//   Typography,
//   Alert,
//   CircularProgress,
//   Button,
// } from '@mui/material';
// import { ArrowBack } from '@mui/icons-material';
// import CreateBusiness from '../components/admin/CreateBusiness';
// import { adminService } from '../services/admin';


// const EditBusinessPage = () => {
//   console.log('🔵 EditBusinessPage rendered');
//   const { tenantId } = useParams();
//   const navigate = useNavigate();
//   const [business, setBusiness] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (tenantId) {
//       fetchBusiness();
//     }
//   }, [tenantId]);

// const fetchBusiness = async () => {
//   try {
//     setLoading(true);
//     const response = await adminService.getBusiness(tenantId);
    
//     // ✅ Extract the actual business data from the nested response
//     // The response structure: { success: true, data: { _doc: { ... } } }
//     const businessData = response.data?._doc || response.data || response;
    
//     setBusiness(businessData);
//   } catch (err) {
//     setError('Failed to load business details');
//     console.error('Error fetching business:', err);
//   } finally {
//     setLoading(false);
//   }
// };

//   const handleSuccess = () => {
//     navigate('/admin/businesses');
//   };


//   if (loading) {
//     return (
//       <Container maxWidth="lg">
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
//           <CircularProgress />
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg">
//       <Box sx={{ py: 4 }}>
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={() => navigate('/admin/businesses')}
//           sx={{ mb: 3 }}
//         >
//           Back to Businesses
//         </Button>

//         {/* <Typography variant="h4" sx={{ mb: 3 }}>
//           Edit Business
//         </Typography> */}

//         {error && (
//           <Alert severity="error" sx={{ mb: 3 }}>
//             {error}
//           </Alert>
//         )}

//         {business && (
//           <CreateBusiness 
//             business={business}
//             isEditMode={true}
//             onSuccess={handleSuccess}
//           />
//         )}
//       </Box>
//     </Container>
//   );
// };

// export default EditBusinessPage;

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, Alert, CircularProgress } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { adminService } from '../services/admin';
import CreateBusiness from './../components/admin/CreateBusiness';

const EditBusinessPage = () => {
  const { tenantId } = useParams();
  const navigate = useNavigate();
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (tenantId) {
      fetchBusiness();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  const fetchBusiness = async () => {
    try {
      setLoading(true);
      const response = await adminService.getBusiness(tenantId);

      // Extract the actual business data from the nested response
      // The response structure: { success: true, data: { _doc: { ... } } }
      const businessData = response.data?._doc || response.data || response;

      setBusiness(businessData);
    } catch (err) {
      setError('Failed to load business details');
      console.error('Error fetching business:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    navigate('/admin/businesses');
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
    <Box sx={{ px: { xs: 2, sm: 3, md: 5 }, pt: 2, pb: 0 }}>
  

  {error && (
    <Alert severity="error" sx={{ mb: 3 }}>
      {error}
    </Alert>
  )}
</Box>

      {business && (
        <CreateBusiness
          business={business}
          isEditMode={true}
          onSuccess={handleSuccess}
        />
      )}
    </Box>
  );
};

export default EditBusinessPage;